import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { Button } from "../components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const headers = () => { const t = localStorage.getItem("cauldron_token"); return t ? { Authorization: `Bearer ${t}` } : {}; };

export default function ProInvoices() {
  const [invoices, setInvoices] = useState({ asProvider: [], asClient: [] });
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("issued");

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/invoices`, { headers: headers() });
        setInvoices(r.data);
      } catch { toast.error("Failed to load"); }
      finally { setLoading(false); }
    })();
  }, []);

  const list = tab === "issued" ? invoices.asProvider : invoices.asClient;

  const openHtml = async (invoiceId) => {
    try {
      // Fetch HTML with auth header, then open as blob.
      const r = await axios.get(`${API}/invoices/${invoiceId}/html`, {
        headers: headers(),
        responseType: "blob",
      });
      const blob = new Blob([r.data], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch { toast.error("Could not open invoice"); }
  };

  return (
    <Layout>
      <div className="max-w-5xl mx-auto p-6" data-testid="pro-invoices">
        <h1 className="text-3xl font-serif text-amber-100 mb-6">Invoices</h1>
        <div className="flex gap-2 mb-4">
          <button
            onClick={() => setTab("issued")}
            className={`px-4 py-2 rounded-md text-sm ${tab === "issued" ? "bg-amber-500 text-neutral-900" : "border border-neutral-800 text-amber-200"}`}
            data-testid="tab-issued"
          >Issued ({invoices.asProvider.length})</button>
          <button
            onClick={() => setTab("received")}
            className={`px-4 py-2 rounded-md text-sm ${tab === "received" ? "bg-amber-500 text-neutral-900" : "border border-neutral-800 text-amber-200"}`}
            data-testid="tab-received"
          >Received ({invoices.asClient.length})</button>
        </div>
        {loading ? (
          <div className="text-amber-200/60">Loading…</div>
        ) : list.length === 0 ? (
          <div className="text-amber-200/60 py-12 text-center text-sm">No invoices yet.</div>
        ) : (
          <ul className="space-y-2" data-testid="invoice-list">
            {list.map(inv => (
              <li
                key={inv.id}
                className="flex justify-between items-center p-4 rounded-lg border border-neutral-800 bg-neutral-900/40 hover:bg-neutral-900/70 transition"
                data-testid={`invoice-${inv.id}`}
              >
                <div>
                  <div className="text-amber-100 text-sm font-mono">{inv.number}</div>
                  <div className="text-xs text-amber-200/50">{new Date(inv.issuedAt).toLocaleDateString()}</div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-amber-100 text-sm">${inv.amount.toFixed(2)}</div>
                  <Button variant="outline" size="sm" onClick={() => openHtml(inv.id)} data-testid={`open-invoice-${inv.id}`}>Open</Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Layout>
  );
}
